import React, { useContext } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container, Row } from "reactstrap";

import "./Auth.css";
import { routesOffice } from "../../routes.js";
import { AuthContext } from "../../context/AuthContext";

const Auth = (props: any) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  // React.useEffect(() => {
  //   document.body.classList.add("bg-default");
  //   return () => {
  //     document.body.classList.remove("bg-default");
  //   };
  // }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent.current) {
      //@ts-ignore
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: any) => {
    return routes.map((prop: any, key: number) => {
      if (prop.layout === "/auth") {
        return (
          //@ts-ignore
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const isAuthLogin =
    location.pathname === "/auth/login" ||
    location.pathname === "/auth/forgot-password" ||
    location.pathname === "/auth/reset-password" || location.pathname === "/auth/activeuser" || location.pathname === "/auth/activeuserinfo";

  return (
    <>
      <div
        // style={{ height: "100%" }}
        className={`bg-gradient-info-custom-bottom ${
          isAuthLogin ? "full-height" : ""
        }`}
        ref={mainContent}
      >
        <div className="bg-gradient-info-custom py-7 py-lg-8"></div>
        <Container className="position-card-login">
          <Row className="justify-content-center">
            <Routes>
              {getRoutes(routesOffice)}
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
